import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { takePendingAppSetup } from '../api/githubApp'
import { GitHubAppSetupView } from '../components/GitHubAppSetupView'
import { ROUTES } from '../constants/routes'

/**
 * An own GitHub App's `setup_url`: GitHub lands here after the App is
 * installed. Continue on the connection's page; recipes put it to use
 * from the Recipes page.
 */
export function GitHubAppSetupDonePage() {
  const navigate = useNavigate()
  // The sessionStorage read is destructive: guard against StrictMode's
  // double effect, which would otherwise consume the id and land on '/'.
  const started = useRef(false)
  useEffect(() => {
    if (started.current) return
    started.current = true
    const connectionId = takePendingAppSetup()
    void navigate(connectionId ? ROUTES.resourceDetail(connectionId) : '/', {
      replace: true,
    })
  }, [navigate])
  return <GitHubAppSetupView error={null} />
}
